import { render, staticRenderFns } from "./ShippingMethodsList.vue?vue&type=template&id=12f7b041"
import script from "./ShippingMethodsList.vue?vue&type=script&lang=js"
export * from "./ShippingMethodsList.vue?vue&type=script&lang=js"
import style0 from "./ShippingMethodsList.vue?vue&type=style&index=0&id=12f7b041&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports